module.exports = __webpack_public_path__ + "media/cases-brand-tommee-lazyload-101.c3247608.mp4";